'use strict';
/* ==========================================================================
   levels/map.js — the hub: the zine's CONTENTS page, a photocopy taped to the corkboard (DESIGN.md §1–§2), with a
   case-board touch. Copied from lessons/simile/levels/map.js. Left: Ms. Park + a speech bubble, and a pinned index card
   ("CASE #2") with red string running to the next step's row. Right: the contents page, one typed entry per lesson.json
   step (so a new step shows up by itself): "p. n", the title in typewriter caps with a dot leader, the tag underneath,
   a doodle in the step's highlighter colour (the clue / POV colours of core-local/narration.js). A finished step gets a
   FACT-CHECKED stamp (its score when Game.progress.scores[id] = {best, of}); the first step not done yet gets a red ink
   "next!" arrow. → Game.replace(new Levels[id]()). On a phone held upright the steps are full-width rows in the
   portrait dock (Dock.map) and the page is only the picture.
   ========================================================================== */
(function () {
  const Z = () => window.Zine;
  const ROW_W = 1000;
  // each step's doodle + highlighter: the video = an eye (who's telling?), the case files = CONTRADICTS, whose head =
  // the omniscient eye, the open mic = BIG FEELINGS
  const MARKS = [{ id: 'first-limited' }, { id: 'contradicts' }, { id: 'third-omniscient' }, { id: 'big-feelings' }, { id: 'others-react' }];
  const SAY = {
    hello: 'The case files are open. Start on page one: no skipping to the verdict.',
    next: 'Good detective work. Turn the page.',
    done: 'All four fact-checked. The mic is yours whenever you want it.',
  };

  function tags() {
    const S = (Game.lesson && Game.lesson.steps) || [], n = Math.max(1, S.length);
    const top = 300, span = 620, gap = span / n, h = Math.min(130, gap - 22);   // rows end above y 930
    let k = 0;
    return S.map((s, i) => {
      const stamps = s.stamp !== false; if (stamps) k++;
      const m = MARKS[i % MARKS.length];
      return { id: s.id, n: stamps ? k : null, title: s.title, sub: s.tag || '', h, x: 1235 + [0, 6, -5, 5, -3][i % 5],
        y: top + (i + 0.5) * gap, rot: [-0.006, 0.005, -0.004, 0.006, -0.003][i % 5], mark: m.id };
    });
  }
  const nextStep = () => tags().find(tg => tg.n != null && !Game.progress.stamps[tg.id]);

  function drawRow(tg, i, hover, t0) {
    const Zn = Z(), s = pop(T, t0 + 0.35 + i * 0.12, 0.4, 2.2);
    if (s <= 0) return;
    const H = tg.h, x0 = -ROW_W / 2;
    g.save();
    g.translate(tg.x, tg.y + (hover ? -5 : 0)); g.rotate(tg.rot); g.scale(s, s);
    if (hover) Zn.mark(tg.mark, x0 + 150, -H * 0.16, ROW_W - 190, H * 0.5, { prog: 1, seed: 70 + i, alpha: 0.45 });
    // the page number, the doodle, the title with its dot leader, the tag
    Zn.type(tg.n == null ? '' : 'p. ' + tg.n, x0 + 10, -H * 0.16, Math.round(H * 0.3), { seed: 80 + i, color: Zn.C.grey });
    Zn.mark(tg.mark, x0 + 96, -H * 0.16, 70, H * 0.46, { prog: 1, seed: 90 + i, alpha: 0.8 });
    Zn.doodle(tg.mark, x0 + 128, -H * 0.16, H * 0.2, { prog: 1, seed: 95 + i });
    const size = Math.round(H * 0.3), title = String(tg.title).toUpperCase();
    const tw = Zn.type(title, x0 + 190, -H * 0.16, size, { t0: t0 + 0.4 + i * 0.12, cps: 60, seed: 100 + i });
    const lead = x0 + 190 + tw + 16, end = ROW_W / 2 - 170;
    if (end > lead + 20) { g.save(); g.fillStyle = 'rgba(20,18,16,0.55)'; for (let x = lead; x < end; x += 16) { g.beginPath(); g.arc(x, -H * 0.12, 2.2, 0, TAU); g.fill(); } g.restore(); }
    hand(tg.sub, x0 + 194, H * 0.26, Math.min(Math.round(H * 0.27), UI.text(36)), t0 + 0.8 + i * 0.12, { align: 'left', color: '#2b4a8c', seed: 58 + i });
    g.restore();
  }

  class MapScene extends Scene {
    enter() {
      const st = Game.progress.stamps, T_ = tags().filter(tg => tg.n != null);
      this.allDone = T_.every(tg => st[tg.id]);
      this.say = this.allDone ? SAY.done : T_.some(tg => st[tg.id]) ? SAY.next : SAY.hello;
      this.stampNew = Game._justStamped; Game._justStamped = null;
      Audio.play('paper', { gain: 0.5 });
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
    }
    open(id) {
      Audio.play('pop', { gain: 0.6 });
      const C = Levels[id];
      if (typeof C === 'function') Game.replace(new C());
      else UI.toast('coming soon');
    }
    keyDown(k) {
      const all = tags(), n = parseInt(k, 10);
      if (n >= 1 && n <= all.length) this.open(all[n - 1].id);
      if (k === 'Enter') this.open((nextStep() || all[0]).id);
    }

    draw() {
      UI.allLessons();
      const t0 = this.enteredAt, t = this.t, docked = UI.docked(), Zn = Z();
      Zn.cork();

      // the contents page
      Zn.page(1235, 580, 1180, 900, { seed: 83, rot: 0.004, tape: 1, dark: 0.45 });
      Zn.staple(700, 168, { rot: -0.6 });
      Zn.type('CONTENTS', 1235, 196, 72, { t0: t0 + 0.15, cps: 22, align: 'center', seed: 304 });
      Zn.highlight(1235 - 190, 200, 380, 58, '#fff04a', { t0: t0 + 0.55, dur: 0.35, seed: 305 });
      Zn.type(`${(Game.lesson && Game.lesson.title) || 'Who\'s Telling This?'} · issue #2`, 1235, 262, 30, { t0: t0 + 0.4, cps: 60, align: 'center', color: Zn.C.grey, seed: 306 });
      Zn.eye(1700, 196, 40, { seed: 307, open: E.outBack(P(T, t0 + 0.6, t0 + 1.0), 1.4) });

      // the case card, pinned behind Ms. Park (the red string to the next step is drawn after the page rows' art)
      if (!docked) {
        Zn.card(560, 960, 250, 160, { seed: 91, rot: -0.05, title: 'CASE #2', s: pop(T, t0 + 0.5, 0.35, 2) });
        hand(this.allDone ? 'closed!' : 'who did it?', 575, 1000, 36, t0 + 0.9, { color: Zn.C.red, rot: -0.05, seed: 92 });
      }
      // Ms. Park + speech (the speech goes into the dock when docked)
      const rise = E.outBack(P(T, t0 + 0.2, t0 + 0.7), 1.4);
      Puppet.draw('park', 330, 1080 + (1 - rise) * 500, 700, { facing: 1, t: T, env: t > 0.6 && t < 3 ? 0.25 + 0.25 * Math.sin(T * 17) : 0 });
      if (docked) Dock.map({ say: this.say, who: (LessonHooks.speakers && LessonHooks.speakers.park || {}).name, open: id => this.open(id) });
      else if (t > 0.6) UI.speech(this.say, 400, 250, { side: 'left', w: 480, t0: t0 + 0.6 });

      // the case-board touch: red string from the case card to the next step's row (the last row when all done)
      const nx = nextStep();
      if (!docked) {
        const to = nx || tags()[tags().length - 1];
        if (to) Zn.string(560, 892, 655, to.y + 90, { t0: t0 + 1.1, dur: 0.6, sag: 30 });
      }
      tags().forEach((tg, i) => {
        const hit = docked ? { hover: false, clicked: false } : UI._hit('tag' + i, tg.x, tg.y, ROW_W, UI.tap(tg.h));
        if (hit.hover && !this['hov' + i]) Audio.play('paper', { gain: 0.2, rate: 1.3 });
        this['hov' + i] = hit.hover;
        drawRow(tg, i, hit.hover, t0);
        if (Game.progress.stamps[tg.id]) {
          let s = 1;
          if (this.stampNew === tg.id) {
            const at = t0 + 0.9;
            s = pop(T, at, 0.18, 1.2) * (1 + 1.4 * (1 - P(T, at, at + 0.12)));
            if (T >= at && !this.stampPlayed) { this.stampPlayed = true; Audio.play('stamp'); }
          } else s = pop(T, t0 + 0.8, 0.25, 1.5);
          const sc = Game.progress.scores && Game.progress.scores[tg.id];
          const label = (Game.lesson.completeCard && Game.lesson.completeCard.title) || 'FACT-CHECKED';
          Zn.stamp(sc && sc.best != null && sc.of ? `${sc.best}/${sc.of}` : label, tg.x + ROW_W / 2 - 110, tg.y + 4, { rot: -0.14, s: s * 0.45 });
        }
        if (!this.allDone && !docked && nx && nx.id === tg.id) {
          const ns = pop(T, t0 + 1.4, 0.4), bob = Math.sin(T * 4) * 8;
          if (ns > 0) {
            g.save(); g.globalAlpha = ns;
            const ax = tg.x - ROW_W / 2 - 30 - bob;
            inkArrow(ax - 90, tg.y - 40, ax, tg.y, { w: 6, color: Zn.C.red, seed: 600 + i, bulge: 20 });
            hand('next!', ax - 70, tg.y + 36, 42, 0, { dur: 0.01, color: Zn.C.red, rot: -0.1, seed: 610 + i });
            g.restore();
          }
        }
        if (hit.clicked) this.open(tg.id);
      });
    }
  }
  MapScene.tags = () => tags().map(tg => ({ id: tg.id, x: tg.x, y: tg.y }));   // tools/integration.js clicks these

  Levels.map = MapScene;
})();
